import React from 'react';
import EvaluatorPaymentItem from '../../../../Domain/EvaluatorPaymentItem';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';

export default class AssignmentPaymentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      ieId: props.id,
      loading: true,
    };
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.state.ieId}
        entityName='Assignment Payment Details'
        type={EvaluatorPaymentItem}
        serviceGetByIdFunction={EvaluatorPaymentService.GetAssignmentPaymentById}
        emptyFieldsEnabled={true}
      />
    );
  }
}
